import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

Sentry.init({
    dsn: 'https://1f2c9126853df39a712618c8c4576e9b@sentry.xoverservices.com/16',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
